import React, {Component} from 'react';

class StatusIcon extends Component {
    render() {

        const className = this.props.value ? 'fa fa-check-square' : 'fa fa-window-close';

        return (
            <i style={{color: this.props.value ? '#27a152' : '#d5656b'}} className={className}></i>
        );
    }
}

export default StatusIcon;


// WEBPACK FOOTER //
// ./src/components/display/StatusIcon.js